<template>
    <div style="display: flex; flex-direction: column; ">
        <MercenaryHeader :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }" />
        <div style="flex: 1; padding: 0 24px; overflow-y: scroll;">
            <div style="margin-top: 20px; padding-bottom: 20px; border-bottom: 1px solid #d9d9d9;">
                <div style="font-weight: 700; font-size: 24px; line-height: 32px;">이곳은 진지하게<br>축구선수의 꿈을 꾸는<br>선수들을 위한 공간입니다</div>
                <div style="margin-top: 20px; font-size: 12px; line-height: 24px; font-weight: 600;">사커하우의 이적시장은 전국 수많은 팀의 현역 감독님들이 선수 영입을 위해 살펴보는 공식 스카우트 공간입니다.</div>
                <div style="font-size: 14px; font-weight: 700; color: var(--color-main); line-height: 24px;">장난식의 지원은 삼가해 주세요</div>
            </div>
            <div style="margin-top: 20px;">
                <div style="font-weight: 700; font-size: 18px; line-height: 24px;">비선출 선수라면 열정을 보여주세요</div>
                <div style="margin-top: 5px; color: #808080; font-weight: 600; font-size: 12px; line-height: 20px;">축구를 향한 진심을 증명하기 위해 아래 2가지 미션 중 하나를 완료해주세요</div>
            </div>
            <div style="display: flex; align-items: center; margin-top: 30px;">
                <div style="display: flex; align-items: center; gap: 10px; flex: 1;">
                    <div style="display: flex; justify-content: center; align-items: center; width: 40px; height: 40px; border-radius: 12px; background-color: #210F031A;">
                        <img style="width: 20px;" :src="require('@/assets/img/training_video_icon.png')" alt="">
                    </div>
                    <div>
                        <div style="font-weight: 700; font-size: 14px; line-height: 24px;">훈련 영상 3회 올리기(하루 최대 1회 가능)</div>
                        <div style="color: #808080; font-weight: 500; font-size: 12px; line-height: 16px;">사커하우의 훈련을 직접 촬영한 훈련 영상 업로드</div>
                    </div>
                </div>
                <div v-if="requestAvailableInfo.training_left_count < 3" style="padding: 8px 12px; background-color: #210F031A; border-radius: 4px; font-weight: 700; font-size: 12px; line-height: 16px; color: #808080;">
                    <span :style="{ color: requestAvailableInfo.training_left_count > 0 ? '#210F03' : '#808080', fontSize: requestAvailableInfo.training_left_count > 0 ? '14px' : '12px' }">{{ requestAvailableInfo.training_left_count }}</span>/3
                </div>
                <div v-else style="padding: 8px 12px; background-color: #210f03; border-radius: 4px; font-weight: 700; font-size: 12px; line-height: 16px; color: #fff;">
                    완료
                </div>
            </div>
            <div style="margin-top: 52px; display: flex; align-items: flex-start;">
                <div style="display: flex; align-items: flex-start; gap: 10px; flex: 1;">
                    <div style="display: flex; justify-content: center; align-items: center; width: 40px; height: 40px; border-radius: 12px; background-color: #210F031A;">
                        <img style="width: 20px;" :src="require('@/assets/img/training_video_icon.png')" alt="">
                    </div>
                    <div>
                        <div style="font-weight: 700; font-size: 14px; line-height: 24px;">인스타그램 인증하기</div>
                        <div style="color: #808080; font-weight: 500; font-size: 12px; line-height: 16px;">스토리에 @soccerhow_official을 태그해<br>업로드한 뒤, 앱에서 인증하기</div>
                    </div>
                </div>
                <template v-if="!writtenInfo">
                    <div v-if="requestAvailableInfo.training_left_count === 0" style="padding: 8px 12px; background-color: #210F031A; border-radius: 4px; font-weight: 700; font-size: 14px; line-height: 16px; color: #808080;">훈련하기</div>
                    <div @click="showInstarCertificationPopup" v-else style="padding: 8px 12px; background-color: var(--color-main); border-radius: 4px; font-weight: 700; font-size: 14px; line-height: 16px; color: #fff;">인증하기</div>
                </template>
                <template v-else>
                    <div v-if="writtenInfo.state == MEMBER_INSTARGRAM_EVENT_STATE.WAITING">
                        <div style="padding: 8px 12px; background-color: #210F031A; border-radius: 4px; font-weight: 700; font-size: 14px; line-height: 16px; color: #808080;">승인 대기중</div>
                    </div>
                    <div v-else-if="writtenInfo.state == MEMBER_INSTARGRAM_EVENT_STATE.REJECTED">
                        <div @click="showInstarCertificationPopup" style="padding: 8px 12px; background-color: var(--color-main); border-radius: 4px; font-weight: 700; font-size: 14px; line-height: 16px; color: #fff;">인증하기</div>
                    </div>
                    <div v-else-if="writtenInfo.state == MEMBER_INSTARGRAM_EVENT_STATE.CERTIFIED">
                        <div style="padding: 8px 12px; background-color: #210f03; border-radius: 4px; font-weight: 700; font-size: 12px; line-height: 16px; color: #fff;">완료</div>
                    </div>
                </template>
            </div>
        </div>
        <div>
            <div @click="goSelectPlayerType" style="padding: 0 24px;">
                <div style="background: linear-gradient(93.97deg, rgba(255, 113, 17, 0.2) 1.51%, rgba(171, 136, 0, 0.2) 100.96%); border-radius: 12px; padding: 12px 24px;">
                    <div style="font-weight: 700; font-size: 12px; color: var(--color-main); line-height: 16px;">혹시 선수 출신이시거나 현재 선수로 활동중이신가요?</div>
                    <div style="font-weight: 500; font-size: 12px; line-height: 16px; margin-top: 4px;">JOINKFA 등록 이력이 있다면,<br>결제 없이 이적시장에 무료 입단 요청서 등록이 가능해요🎉</div>
                </div>
            </div>
            <div style="padding: 0 12px;">
                <div @click="goGround" v-if="!isCompleteMission" class="footer_btn">그라운드로 이동하기</div>
                <div @click="writeRequestForm" v-else class="footer_btn active">입단 요청서 작성하기</div>
            </div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import { MEMBER_INSTARGRAM_EVENT_STATE } from '@/Constants'

export default {
    name: 'RequestFormGuide',
    components: {
        MercenaryHeader
    },
    props: {
        playerType: {
            type: String,
            default: ''
        },
        writeRequestForm: {
            type: Function,
            default: () => {}
        }
    },
    created() {
        console.log(this.playerType)
        this.getReqeustAvalibale()
        this.getisWriteInstargramEvent()
    },
    data() {
        return {
            MEMBER_INSTARGRAM_EVENT_STATE: MEMBER_INSTARGRAM_EVENT_STATE,
            requestAvailableInfo: {},
            writtenInfo: null
        }
    },
    computed: {
        isCompleteMission() {
            const isComplete = this.requestAvailableInfo.is_available || (this.writtenInfo && this.writtenInfo.state == MEMBER_INSTARGRAM_EVENT_STATE.CERTIFIED)
            return isComplete
        }
    },
    methods: {
        async getReqeustAvalibale() {
            const res = await this.$Axios.get('/api/soccerhow/request/available/info')
            this.requestAvailableInfo = res.data
        },
        async getisWriteInstargramEvent() {
            const res = await this.$Axios.get('/api/soccerhow/request/instargram_event/certified')
            this.writtenInfo = res.data.member_instargram_event
        },
        showInstarCertificationPopup() {
            this.$GlobalStore.addModal('UploadInstaImage', {
                transitionName: '',
                isModalBackTransparent: true,
                completeAction: () => {
                    this.getisWriteInstargramEvent()
                    this.getReqeustAvalibale()
                }
            })
        },
        goGround() {
            this.$GlobalStore.closeModalAll()
            this.$router.push({ path: '/view/soccer_learn?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        goSelectPlayerType() {
            this.$GlobalStore.addModal('SelectPlayerType', { isElite: true });
        }
    }
}
</script>

<style scoped>
.footer_btn {
    width: 100%;
    text-align: center;
    height: 48px;
    line-height: 48px;
    background-color: #210f03;
    color: #fff;
    font-weight: 700;
    border-radius: 12px;
    margin-bottom: 20px;
    margin-top: 20px;
    font-size: 14px;
}

.footer_btn.active {
    background-color: var(--color-main);
    color: #fff;
}
</style>